import React from "react";
import { Textarea } from "components";

const ThemeField = ({ value, onChange }) => (
  <div className="cg-field">
    <label className="cg-field-label" htmlFor="cg-theme">
      Tell us about your game <span className="opt">optional, but worth it</span>
    </label>
    <Textarea
      id="cg-theme"
      rows={5}
      placeholder={`What's it about, who's playing, what's the vibe? The more you tell us, the more we tailor it. For example:

• A trivia night for my book club — we love 90s fantasy, bad puns, and pop culture. Keep it PG.
• An office holiday party, heavy on movies and music, with a round about our own team.
• My dad's 60th — classic rock, world history, and a little golf.`}
      value={value}
      maxLength={500}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default ThemeField;
